import useAPI from '@/hooks/useAPI';
import ActivityLogsRepository from '@/repositories/ActivityLogsRepository';

export const useActivityLogByFormAnswerGroupId = (formAnswerGroupHealthieId: string) => {
  const activityLogsRepository = ActivityLogsRepository();

  return useAPI({
    queryKey: ['getActivityLogByFormAnswerGroupId', formAnswerGroupHealthieId],
    queryFn: async () => {
      return await activityLogsRepository.getActivityLogByFormAnswerGroupId(
        formAnswerGroupHealthieId
      );
    }
  });
};

export default {};
